import React from "react";
import { useState } from "react";
import swal from 'sweetalert';
import GetAllActivities from '../api/Activities'

import 
    LogInUser
    
 from '../api/Login';

const BASE = 'https://fitnesstrac-kr.herokuapp.com/api';



const Login = (props => {

  const [username, setCurrentUsername] = useState("");
  const [password, setCurrentPassword] = useState("");
  
  const {user, setUser, token, setToken, activity, setActivity } = props

  return (
    <>
    
    <div className="log-in">
        
        { token && user ? <div>&nbsp;&nbsp;&nbsp;You are now logged in!&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<button onClick={(event) => {
            event.preventDefault();
            localStorage.clear();
            setToken('');
            setUser({});
            swal("Are you sure you want to do this?", {
              buttons: ["No, don't log me out", "Yes, I am sure"],
            });
    
        }}>
            LOG-OUT</button></div> : <span><b><i>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Enter your username and email to login!</i></b></span>}
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <form id="log-in-form">
      &nbsp;&nbsp;&nbsp;username&nbsp;<input type="text" value ={username} placeholder="username" onChange={(event )=> {
            event.preventDefault();
            let username = event.target.value;
            
            return setCurrentUsername(username);
            
        }}></input>
        &nbsp;&nbsp;&nbsp;password&nbsp;
        <input
          type="text"
          value={password}
          onChange={(event) => {
            event.preventDefault();
            let password = event.target.value;
            
            return setCurrentPassword(password);
          }}
          placeholder="password"
        ></input>
      </form>
      &nbsp;&nbsp;&nbsp;
      <button
        id="submit-info"
        value={username, password}
        onClick={ async (event)=> {
            event.preventDefault();
            try {
                let {user, message, token} = await LogInUser(username, password)
                setToken(token); 
                
                if(message){
                  swal(`${message}`)
                }
                swal(`Welcome back ${user.username}!`, "You are now logged in!", "success");
                GetAllActivities().then(setActivity)
                setUser(user)
                
                user ? localStorage.setItem('user', JSON.stringify(user)) : ""
                
                if(token) localStorage.setItem('token', JSON.stringify(token));
                
                
                
            } catch (error) {
                console.error(error);
            }
        }}
      >
        LOGIN
      </button>
      &nbsp;&nbsp;&nbsp;
      {!user && !token ? <div>Login to continue</div> : <><span>What should we do today?</span></>}
    </div>
    </>
  );
  
});

export default Login;